import React, { useState } from 'react';
import { truncate } from '@/utils/truncate';
import toast from 'react-hot-toast';
import { createAuction } from '@/services/Auction/auction-blockchain';
import {
  useWeb3ModalAccount,
  useWeb3ModalProvider,
} from '@web3modal/ethers5/react';
import { BaseModal, Button, Divider, Flex, Input, Select, Tabs } from '@/lib';
import { FormProvider, useForm } from 'react-hook-form';
import styles from './PutOnSaleModal.module.scss';
import { useConnectBahamut } from '@/hooks/useConnectBahamut';
// import { CustomCalendar } from '../CustomCalendar';

const MARKETPLACE_FEE = 5;

const EXPIRATION_OPTIONS = [
  { label: '1 Day', value: '86400' },
  { label: '7 Days', value: '604800' },
  { label: '1 Month', value: '2629800' },
  { label: '3 Month', value: '7889400' },
];

export const PutOnSaleModal = ({ cardData, onClose }) => {
  const methods = useForm({
    defaultValues: {
      expirationDate: '',
      startingBid: 0,
      price: '',
      biddable: true,
    },
    mode: 'onChange',
  });
  const { setValue, watch, handleSubmit } = methods;
  const [expirationPeriod, setExpirationPeriod] = useState(
    EXPIRATION_OPTIONS[0],
  );
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const handleExpirationPeriodChange = (value) => {
    setExpirationPeriod(value);
  };

  const { isConnected } = useWeb3ModalAccount();
  const { walletProvider } = useWeb3ModalProvider();
  const biddable = watch('biddable');
  const price = watch('price');
  const { chainId } = useWeb3ModalAccount();
  const { connect } = useConnectBahamut(chainId);

  const onSell = async (data) => {
    setButtonDisabled(true);

    if (!isConnected) {
      connect();
      return;
    }

    toast.loading(
      'It may take up to a couple minutes to process. Please wait...',
    );

    try {
      await createAuction({
        token_id: cardData.token_id,
        collection_address: cardData.collection_address,
        price: biddable ? data.startingBid : data.price,
        buyoutPrice: data.price,
        biddable: data.biddable,
        duration: expirationPeriod.value,
        walletProvider,
      });
      toast.dismiss();
      toast.success('Item has been put on sale');
      setTimeout(() => {
        window.location.reload();
      }, 1000);
      setButtonDisabled(false);
    } catch (e) {
      toast.dismiss();
      toast.error('Error while putting item on sale');
      setButtonDisabled(false);
    }
  };

  const royalty = cardData?.royalty;

  const earnValue = truncate(price - price * (royalty / 10000 + 0.05));

  const info = [
    {
      title: "You'll earn",
      value: (
        <Flex align="center" gap={6}>
          <img
            loading="lazy"
            src="/webp/networksWhite.webp"
            width={20}
            height={20}
            alt="networks"
          />
          <p>{earnValue ? earnValue : 0} FTN</p>
        </Flex>
      ),
    },
    { title: 'Marketplace Fee', value: `${MARKETPLACE_FEE}%` },
    { title: 'Royalty', value: `${cardData?.royalty / 100}%` },
  ];

  return (
    <BaseModal onClose={onClose} title="Put on sale" width="460px">
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSell)}>
          <Flex vertical gap={30}>
            <Flex gap={14} align="center" className={styles.previewCard}>
              <img
                loading="lazy"
                className={styles.preview}
                src={cardData?.image}
                alt="preview"
              />
              {cardData?.name}
            </Flex>
            <Flex vertical gap={10}>
              Type of sale
              <Tabs
                tabs={[
                  {
                    title: 'Live auction',
                    value: true,
                  },
                  {
                    title: 'Fixed price with offers',
                    value: false,
                  },
                ]}
                value={biddable}
                onChange={(val) => {
                  setValue('biddable', val);
                }}
              />
            </Flex>
            <Select
              title="Date of listing expiration"
              selected={expirationPeriod}
              options={EXPIRATION_OPTIONS}
              onChange={handleExpirationPeriodChange}
            />
            {biddable && (
              <Input
                name="startingBid"
                type="number"
                label="Starting bid"
                placeholder={0}
                required
              />
            )}
            <Flex vertical gap={20}>
              <Input
                name="price"
                type="number"
                pattern="[0-9]*"
                label="Set Buyout Price"
                placeholder={0}
                required
              />

              <Flex vertical gap={14} className={styles.infoBlock}>
                {info.map(({ title, value }) => (
                  <Flex justify="space-between" key={title}>
                    <div className={styles.infoTitle}>{title}</div>
                    <div>{value}</div>
                  </Flex>
                ))}
                <Divider />
                <Flex justify="space-between" align="center">
                  <div className={styles.infoTitle}>Listing price</div>
                  <div className={styles.infoTotal}>
                    <Flex align="center" gap={6}>
                      <img
                        src="/webp/networksWhite.webp"
                        width={30}
                        height={30}
                        alt=""
                      />
                      {price} FTN
                    </Flex>
                  </div>
                </Flex>
              </Flex>
            </Flex>
            <Button disabled={buttonDisabled} type="submit">
              Sell
            </Button>
          </Flex>
        </form>
      </FormProvider>
    </BaseModal>

    //           <div className="grow shrink basis-0 self-stretch text-white text-base font-normal font-['Archivo'] leading-normal">
    //             <span>
    //               {expirationDateValue === 'Custom' ||
    //               expirationDateValue == null
    //                 ? `${diff.days} d ${diff.hours} h ${diff.minutes} m ${diff.seconds} s`
    //                 : expirationValue}
    //             </span>
    //           </div>
    //           <div className="justify-start items-center gap-2.5 flex">
    //             <div className="opacity-50 text-right text-white text-base font-normal font-['Archivo'] leading-normal">
    //               {dayjs(
    //                 diff.formattedDate != 'Invalid Date'
    //                   ? diff.formattedDate
    //                   : new Date(),
    //               ).format('DD.MM.YYYY hh:mm A')}
    //             </div>
    //             <div className="w-[18px] h-[18px] relative">
    //               <img loading='lazy' src="/webp/Down.svg" alt="" />
    //             </div>
    //           </div>
    //         </div>
    //         {flag && (
    //           <div
    //             style={{ backgroundColor: '#1d1e24ed', opacity: 1 }}
    //             className="w-[420px] h-[228px]   flex-col justify-start items-center inline-flex z-11 days-container rounded-[20px] border border-white-30 absolute top-[310px]"
    //           >
    //             <div
    //               style={{ backgroundColor: '#1D1F2466', opacity: 1 }}
    //               className="w-[420px] h-[235px] p-1 border-white flex-col justify-start items-center inline-flex z-10 days-container rounded-[20px] border border-white-30 backdrop-blur-xl absolute"
    //             >
    //               {expirationDates.map((i) => (
    //                 <SelectItem
    //                   title={i.title}
    //                   value={i.value}
    //                   onClick={(val) => {
    //                     onSelect(val, i.title);
    //                   }}
    //                   key={i.title}
    //                 />
    //               ))}
    //               <SelectItem
    //                 title={'Custom'}
    //                 value={'Custom'}
    //                 onClick={() => {
    //                   setExpirationDateValue('Custom');
    //                   setFlag(!flag);
    //                 }}
    //               />
    //             </div>
    //           </div>
    //         )}
  );
};
